// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_az-3";
export var contentContainer = "_az-0";
export var editorContainer = "_az-1";
export var quillInputForm = "_az-2";
export var zoneDivider = "_az-4";